import React from 'react';
import { connect } from 'react-redux';
import Chevron from './user-dashboard/utility/Chevron';
import { getTenantState } from '../store/selectors';
import languageDropdownIcon from './languageDropdownIcon';
import { setCurrentLocale } from '../store/actions';

const localeCodeToExtendedCode = {
  en: 'Eng',
  es: 'Spa',
  fr: 'Fra',
};

class LanguageDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.handleDropdownSelection = this.handleDropdownSelection.bind(this);
    this.handleHeaderClick = this.handleHeaderClick.bind(this);
  }

  get btnBackgroundColor() {
    return !this.props.lowProfile ? this.props?.tenant?.primary : 'white';
  }

  get btnForegroundColor() {
    return !this.props.lowProfile ? 'white' : this.props?.tenant?.primary;
  }

  headerStyles = { backgroundColor: this.btnBackgroundColor };

  componentDidMount = () => {
    window.addEventListener('click', this.handleWindowClick);
  };

  componentWillUnmount = () => {
    window.removeEventListener('click', this.handleWindowClick);
  };

  handleHeaderClick(e) {
    this.setState((state) => ({
      isOpen: !state.isOpen,
    }));
  }

  handleWindowClick = (e) => {
    if (!e.composedPath().find((el) => el.name === 'dropdown_header')) {
      this.setState({ isOpen: false });
    }
  };

  handleDropdownSelection(localeCode) {
    this.props.setCurrentLocale(localeCode); // update Redux
  }

  get allowedLocalesForTenant() {
    if (this.props.tenant.name === 'ASU') {
      return ['en', 'es'];
    }

    if (this.props.tenant.name === 'Baobab') {
      return ['en', 'fr'];
    }

    return [];
  }

  get languageOptions() {
    return Object.entries(localeCodeToExtendedCode)
      .filter(
        ([localeCode]) =>
          this.allowedLocalesForTenant.includes(localeCode) &&
          localeCode !== this.props.currentLocale
      )
      .map(([localeCode, extendedCode]) => ({
        localeCode,
        extendedCode,
      }));
  }

  render() {
    return (
      <div
        className="lang-dropdown-wrapper"
        hidden={!this.allowedLocalesForTenant.length}
      >
        <button
          type="button"
          tabIndex={0}
          name="dropdown_header"
          className="button--primary lang-dropdown-button"
          style={this.headerStyles}
          onClick={this.handleHeaderClick}
        >
          <span className="lang-dropdown-btn-icon">
            {languageDropdownIcon({
              sideLength: '24px',
              color: this.btnForegroundColor,
            })}
          </span>
          <span
            className="lang-dropdown-btn-text"
            style={{ color: this.btnForegroundColor }}
          >
            {localeCodeToExtendedCode[this.props.currentLocale] || ''}
          </span>
          <Chevron
            color={this.btnForegroundColor}
            transform={`rotate(${this.state.isOpen ? 270 : 90}deg)`}
            ariaLabel={`${
              this.state.isOpen
                ? 'Click to close dropdown'
                : 'Click to open dropdown'
            }`}
          />
        </button>
        <div className="lang-dropdown-options" hidden={!this.state.isOpen}>
          {this.languageOptions.map((codes) => {
            return (
              <div
                role="button"
                tabIndex={0}
                className="lang-individual-option"
                key={codes.localeCode}
                onClick={() => {
                  this.handleDropdownSelection(codes.localeCode);
                }}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key))
                    this.handleDropdownSelection(codes.localeCode);
                }}
              >
                <span
                  className="lang-option-outline"
                  style={{ color: this.props?.tenant?.primary }}
                >
                  {codes.extendedCode}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const { currentLocale } = state;

  return { tenant, currentLocale };
};

export default connect(mapStateToProps, { setCurrentLocale })(LanguageDropdown);
